import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = ({ onGetStarted, onDownloadBlueprint }) => {
  return (
    <section className="bg-gradient-to-br from-brand-primary via-blue-800 to-brand-secondary text-white py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-8">
            <Icon name="Zap" size={16} className="mr-2" />
            Start Your AI Independence Journey Today
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
            Transform Your Organization with
            <span className="block text-brand-accent">AI Clean Core</span>
          </h1>
          
          <p className="text-xl lg:text-2xl text-blue-100 mb-12 leading-relaxed">
            Break free from vendor lock-in. Build internal AI capabilities that give you complete control over your organization's AI destiny.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              variant="default"
              size="lg"
              className="bg-brand-accent hover:bg-brand-accent/90 text-gray-900 font-semibold px-8 py-4"
              iconName="Calendar"
              iconPosition="left"
              onClick={onGetStarted}
            >
              Schedule Strategic Consultation
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-brand-primary px-8 py-4"
              iconName="Download"
              iconPosition="left"
              onClick={onDownloadBlueprint}
            >
              Download AI Survival Blueprint
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-brand-accent/20 rounded-lg flex items-center justify-center mb-3">
                <Icon name="Clock" size={24} className="text-brand-accent" />
              </div>
              <div className="text-2xl font-bold">15 min</div>
              <div className="text-blue-200">Quick Assessment</div>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-brand-accent/20 rounded-lg flex items-center justify-center mb-3">
                <Icon name="Users" size={24} className="text-brand-accent" />
              </div>
              <div className="text-2xl font-bold">500+</div>
              <div className="text-blue-200">Organizations Transformed</div>
            </div>
            
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 bg-brand-accent/20 rounded-lg flex items-center justify-center mb-3">
                <Icon name="TrendingUp" size={24} className="text-brand-accent" />
              </div>
              <div className="text-2xl font-bold">85%</div>
              <div className="text-blue-200">Cost Reduction Average</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;